import React from 'react'
import { css, cx } from '@emotion/css'
import ReactModal from 'react-modal'

export interface ModalProps {
  isOpen: boolean
  onRequestClose: () => void
  children: React.ReactNode
  className?: string
}

const openTimeInSeconds = 0.425
const closeTimeInSeconds = 0.3

const getOverlayClasses: (className?: string) => ReactModal.Classes = (
  className
) => ({
  base: cx(
    css`
      z-index: 1051;
      position: fixed;
      top: 0px;
      left: 0px;
      right: 0px;
      bottom: 0px;
      display: block;
      overflow-y: auto;
      background-color: rgba(0, 0, 0, 0);
      transition: background-color ${openTimeInSeconds}s linear;
    `,
    className
  ),
  afterOpen: css`
    background-color: rgba(0, 0, 0, 0.3);
  `,
  beforeClose: css`
    transition: background-color ${closeTimeInSeconds}s linear;
    background-color: rgba(0, 0, 0, 0);
  `
})

const contentClasses: ReactModal.Classes = {
  base: css`
    position: relative;
    margin: 50px auto;
    min-height: calc(100vh - 100px);
    outline: none;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform ${openTimeInSeconds}s ease-out;
    transform: translate(0, -100vh);
    pointer-events: none;

    > * {
      margin-bottom: 150px;
    }
  `,
  afterOpen: css`
    transform: translate(0, 0);
  `,
  beforeClose: css`
    transition: transform ${closeTimeInSeconds}s ease-out;
    transform: translate(0, -100vh);
  `
}

export function Modal({
  isOpen,
  onRequestClose,
  children,
  className
}: ModalProps) {
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overlayClassName={getOverlayClasses(className)}
      className={contentClasses}
      closeTimeoutMS={closeTimeInSeconds * 1000}
      ariaHideApp={false}
      shouldCloseOnEsc
      shouldCloseOnOverlayClick={false}
    >
      {children}
    </ReactModal>
  )
}
